import React from 'react';
import {Button} from 'reactstrap';

var DatePicker = require('react-datepicker');
require('moment');
require('react-datepicker/dist/react-datepicker.css');


export default class Filters extends React.Component {

    constructor(props) {
        super(props);
        this.getData = this._getData.bind(this);
        this.filterChanged = this._filterChanged.bind(this);
        this.requestXlsx = this._requestXlsx.bind(this);
        this.state = {
            territory_id:       0,
            coordination_id :   0,
            user_id :           0,
            since :             null,
            until :             null,
        }
    }

    _getData() {
        const filters = [
            'territory_id',
            'coordination_id',
            'user_id',
            'since',
            'until'
        ];
        return filters.reduce((data, key) => {
            if(this.state[key]) {
                data[key] = this.state[key];
            }
            return data;
        }, {});

    }

    _filterChanged(key, value) {

        const chained = [
            'territory_id',
            'coordination_id',
            'user_id',
        ];

        const newState = {
            [key] : value
        };
        const idx = chained.indexOf(key);
        if(idx >= 0) {
            for(let i = idx + 1; i< chained.length; i++) {
                newState[chained[i]] = 0;
            }
        }


        this.setState(newState, () => {
            if(this.props.onFilterChange) {
                this.props.onFilterChange(this.getData());    
            }
        });
    }

    _requestXlsx() {
        const filters = this.getData();
        const report = this.props.report;
        this.props.requestXlsx(report, filters);
    }

    render() {

        const territories = Object.values(this.props.territories.data);
        let coordinations = Object.values(this.props.coordinations.data);
        if(this.state.territory_id !== 0) {
            coordinations = coordinations.filter(coordination => this.state.territory_id === coordination.territory_id);
        }
        const users = this.props.users.data.filter(user => {
            if(user.role !== 'asesor') return false;
            if(this.state.territory_id !== 0) {
                if(user.territory_id !== this.state.territory_id) return false;
            }
            if(this.state.coordination_id !== 0) {
                if(user.coordination_id !== this.state.coordination_id) return false;
            }
            return true;
        });

        return (
            <div className="container">
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Territorio</label>
                            <select value={this.state.territory_id} className="form-control" onChange={(event) => this.filterChanged('territory_id', parseInt(event.target.value, 10))}>
                                <option value={0}>
                                    Todos los territorios
                                </option>
                                {
                                    territories.map(territory => 
                                        <option key={territory.id} value={territory.id}>
                                            {territory.name}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Coordinación</label>
                            <select value={this.state.coordination_id} className="form-control" onChange={(event) => this.filterChanged('coordination_id', parseInt(event.target.value, 10))}>
                                <option value={0}>
                                    Todas las coordinaciones
                                </option>
                                {
                                    coordinations.map(coordination => 
                                        <option key={coordination.id} value={coordination.id}>
                                            {coordination.name}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Ejecutivos</label>
                            <select value={this.state.user_id} className="form-control" onChange={(event) => this.filterChanged('user_id', parseInt(event.target.value, 10))}>
                                <option value={0}>
                                    Todos los Ejecutivos
                                </option>
                                {
                                    users.map(user => 
                                        <option key={user.id} value={user.id}>
                                            {user.name}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-3">
                        <Button color="primary" className="w-100" style={{ marginTop : '2em'}} onClick={this.requestXlsx}>
                            <i className="fa fa-download"></i> Descargar Excel
                        </Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Desde</label>
                            <DatePicker
                                locale='es'
                                dateFormat="DD/MM/YYYY"
                                className="form-control"
                                placeholderText="DD/MM/YYYY"
                                selected={this.state.since}
                                onChange={(date) => this.filterChanged('since', date)} />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Hasta</label>
                            <DatePicker
                                locale='es'
                                dateFormat="DD/MM/YYYY"
                                className="form-control"
                                placeholderText="DD/MM/YYYY"
                                selected={this.state.until}
                                onChange={(date) => this.filterChanged('until', date)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/Filters.jsx
 **/